export const FIREBASE_CONNECTED = 'FIREBASE_CONNECTED';
export const FIREBASE_DISCONNECTED = 'FIREBASE_DISCONNECTED';
export const FIREBASE_AUTHENTICATED = 'FIREBASE_AUTHENTICATED';
export const FIREBASE_UNAUTHENTICATED = 'FIREBASE_UNAUTHENTICATED';

export const firebaseConnected = () => ({
  type: FIREBASE_CONNECTED,
});

export const firebaseDisconnected = () => ({
  type: FIREBASE_DISCONNECTED,
});

export const firebaseAuthenticated = uid => ({
  type: FIREBASE_AUTHENTICATED,
  uid,
});

export const firebaseUnAuthenticated = () => ({
  type: FIREBASE_UNAUTHENTICATED,
});



// WEBPACK FOOTER //
// ./src/actions/firebase.js